import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';
import LightBox from '../../LightBox';
import { colors, fontSize } from '../../../constants/styleConstants';
import { MEDIA_TAGS_TYPES_IDS, MEDIA_TYPES_IDS, TP } from '../../../constants/consts';
import FbPagination from '../../FbPagination';
import { getList } from '../../../containers/App/actions';
import { getArtistImagesAction } from '../../../containers/Artist/actions';
import { MEDIA } from '../../../constants/endpointConstants';
import ImageSet from '../../ImageSet';

const useStyles = makeStyles((theme) => ({
  imageWrapper: {
    border: 'none',
    padding: 0,
    height: 200,
    margin: '0 5px 5px 0 !important',
    cursor: 'pointer',
    width: 'auto !important',
    minWidth: '0 !important',
    overflowX: 'hidden',
    overflowY: 'hidden',
    [theme.breakpoints.down('md')]: {
      height: 150,
    },
  },
  img: {
    height: '100%',
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto',
  },
  viewTitle: {
    fonSize: fontSize.basic,
    color: colors.grey3,
    fontWeight: 'bold',
    marginBottom: 16,
  },
  gridList: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));

const ArtistImages = ({ t, photos }) => {
  const classes = useStyles();
  const [isOpenedLightBox, setLightBoxOpen] = React.useState(false);
  const [chosenPhoto, setPhotoNumber] = React.useState(0);

  const openLightBox = photoNumber => {
    setPhotoNumber(photoNumber);
    setLightBoxOpen(true);
  };
  const dispatch = useDispatch();

  const getImages = useCallback(
    pagination => {
      const profileId = photos?.criteria?.media_tag_id;
      dispatch(
        getList({
          endpoint: MEDIA,
          sagaRoutine: getArtistImagesAction,
          params: {
            queryParams: {
              media_type_id: MEDIA_TYPES_IDS.IMAGE,
              media_tag_type_id: MEDIA_TAGS_TYPES_IDS.PROFILE,
              media_tag_id: profileId,
            },
            pagination,
          },
        }),
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [photos],
  );

  return (
    <>
      <div className={classes.viewTitle}>{t(`${TP}.m_IMAGES`)}</div>
      <div className={classes.content}>
        <GridList className={classes.gridList}>
          {(photos?.data || []).map((image, index) => (
            <button key={image.id} type="button" className={classes.imageWrapper} onClick={() => openLightBox(index)}>
              <ImageSet
                images={image?.file?.urls}
                src={get(image, 'file.urls.medium') || get(image, 'url')}
                alt={get(image, 'description', '')}
                className={classes.img}
              />
            </button>
          ))}
          </GridList>
        {photos?.data?.length === 0 && t(`${TP}.m_ARTIST_NO_PHOTOS`)}
        {photos?.total > 50 && <FbPagination filters={photos} fetchFunction={getImages} />}
      </div>
      <LightBox
        images={photos?.data || []}
        isOpened={isOpenedLightBox}
        closeLightBox={() => setLightBoxOpen(false)}
        chosenImage={chosenPhoto}
      />
    </>
  );
};

ArtistImages.propTypes = {
  photos: PropTypes.object,
  t: PropTypes.func,
};

ArtistImages.defaultProps = {
  photos: { data: [] },
};

export default ArtistImages;
